import { motion, useInView } from "framer-motion";
import { useRef, useState } from "react";
import { ChevronDown } from "lucide-react";

const AnimatedBlock = ({ children, delay = 0 }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-60px" });
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 30 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.7, delay, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
};

const faqs = [
  {
    q: "A che ora sono le chiamate di gruppo di Light Workers\u2019 House?",
    a: "Puoi guardare i contenuti quando vuoi. Le live sono generalmente fra settimana alle 18:30. Tutti gli incontri sono registrati e avrai accesso alle registrazioni nel portale dedicato.",
  },
  {
    q: "Posso pagare l\u2019abbonamento a rate?",
    a: "S\u00ec.\nSe desideri entrare in Light Workers\u2019 House con il Piano Annuale, puoi scegliere anche il pagamento rateale con comoda quota mensile a 65 euro al mese.\n\nMentre per il semestrale, puoi usare Klarna o PayPal come pagamento rateale.",
  },
  {
    q: "Posso avere un supporto individuale da Alessia?",
    a: "S\u00ec.\nSe senti il desiderio di essere accompagnata/o in modo ancora pi\u00f9 personale, puoi scegliere OLTRE \u2013 Light Workers\u2019 House + Mentoring 1:1.\n\nOLTRE include tutto ci\u00f2 che trovi all\u2019interno di Light Workers\u2019 House, ma aggiunge un accompagnamento individuale di 6 mesi con Alessia:\n\u2022 10 sessioni individuali da 90 minuti\n\u2022 Supporto personale via Telegram tra una sessione e l\u2019altra\n\u2022 Un percorso costruito interamente intorno a te, ai tuoi obiettivi e al tuo momento di vita.\n\n\u00c8 la soluzione ideale per chi desidera accelerare la propria trasformazione ed essere accompagnata/o passo dopo passo.",
  },
  {
    q: "Quando inizia il percorso?",
    a: "Il tuo percorso inizia nel momento stesso in cui scegli di entrare.\nAppena completata l\u2019iscrizione riceverai l\u2019accesso immediato a Light Workers\u2019 House e potrai iniziare fin da subito a esplorare l\u2019intera libreria dei contenuti gi\u00e0 disponibili.\n\nTroverai tutte le Live di formazione, i Cerchi di Luce, le pratiche, le meditazioni e i materiali pubblicati a partire da maggio 2026, oltre a tutti i nuovi contenuti che verranno aggiunti nei mesi successivi.\n\nSe hai scelto OLTRE \u2013 Light Workers\u2019 House + Mentoring 1:1, dopo l\u2019iscrizione verrai contattata/o direttamente da Alessia per concordare insieme la data della prima sessione individuale e costruire il tuo percorso personalizzato.",
  },
  {
    q: "Gli eventi dal vivo avranno un contributo extra?",
    a: "Gli eventi e i lavori mirati organizzati direttamente da me avranno un costo aggiuntivo, per voi comunque agevolato. Saranno inoltre previsti eventi di community gratuiti, con il solo contributo per la condivisione della sala e di pranzo/cena.",
  },
  {
    q: "Posso pagare tramite bonifico bancario?",
    a: "S\u00ec, nel caso contattami tramite info@stellasoulcoach.com oppure via DM su Instagram (@stella_soul_coach).",
  },
  {
    q: "Qual \u00e8 il piano pi\u00f9 adatto a me?",
    a: "Dipende dal momento che stai vivendo.\n\n\u2764\ufe0f\u200d\ud83d\udd25 Light Workers\u2019 House Semestrale\n\u00c8 la scelta ideale se desideri iniziare il tuo percorso di crescita personale e spirituale all\u2019interno della Community. Per sei mesi lavorerai insieme ad altre anime in cammino, partecipando alle Live, ai Cerchi di Luce e a tutte le esperienze della Membership. \u00c8 perfetto se senti che questo \u00e8 il momento giusto per iniziare a mettere te stessa/o al centro.\n\n\u2764\ufe0f\u200d\ud83d\udd25 Light Workers\u2019 House Annuale\n\u00c8 la scelta migliore per chi desidera fare della propria crescita uno stile di vita. Dodici mesi ti permettono di integrare realmente i cambiamenti, consolidare nuove abitudini e vivere ogni fase della trasformazione con continuit\u00e0. Inoltre \u00e8 il piano economicamente pi\u00f9 vantaggioso.\n\n\u2764\ufe0f\u200d\ud83d\udd25 OLTRE \u2013 Light Workers\u2019 House + Mentoring 1:1\n\u00c8 la scelta per chi sente di non voler semplicemente crescere, ma accelerare la propria trasformazione. Oltre a tutto ci\u00f2 che offre Light Workers\u2019 House, lavorerai direttamente con Alessia attraverso un percorso individuale di 6 mesi, con sessioni personalizzate e supporto costante. Se senti che questo \u00e8 un momento di svolta della tua vita e desideri una guida al tuo fianco, OLTRE \u00e8 il contenitore pi\u00f9 completo.",
  },
  {
    q: "Posso annullare la mia iscrizione quando voglio?",
    a: "Se scegli il Piano Annuale, l\u2019acquisto rappresenta un impegno di 12 mesi. Anche se hai scelto il pagamento rateale, dovranno essere corrisposte tutte le 12 rate previste fino al completamento dell\u2019abbonamento.\n\nSe scegli il Piano Semestrale, l\u2019impegno \u00e8 di 6 mesi, al termine dei quali il rinnovo potr\u00e0 essere disattivato.\n\nUna volta terminato il periodo acquistato, il rinnovo non verr\u00e0 effettuato se lo avrai disattivato in precedenza.\n\nN.B.: Non sono previsti rimborsi per gli abbonamenti gi\u00e0 acquistati.",
  },
  {
    q: "Che succede se non riesco a partecipare ad una sessione live?",
    a: "Tutti gli incontri, a partire dalle live mensili di formazione, i Cerchi di Luce e i workshop con i professionisti sono registrati e, se non potrai unirti per qualsiasi motivo, avrai la possibilit\u00e0 di rivederli successivamente.",
  },
  {
    q: "Quanto dura il percorso?",
    a: "Light Workers House non ha scadenza! Finch\u00e9 la tua iscrizione a pagamento sar\u00e0 attiva, avrai sempre accesso a tutte le lezioni disponibili all\u2019interno della piattaforma e al Gruppo Membri esclusivo.",
  },
  {
    q: "Come ottengo supporto giornaliero dalla Community?",
    a: "Non appena ti iscriverai a Light Workers House, entrerai a far parte della Community privata su Telegram. Qui potrai condividere le tue riflessioni e ci\u00f2 che accade nel tuo percorso con Alessia e con gli altri Guerrieri di Luce presenti. La Community sar\u00e0 il tuo luogo sicuro, uno spazio in cui potrai portare avanti il tuo percorso di crescita e risveglio, sentendoti incoraggiata/o, compresa/o e sostenuta/o.",
  },
  {
    q: "Come mantengo un rapporto personale con la Coach, Alessia?",
    a: "A differenza di programmi con 50\u2013100+ membri, questo percorso nasce volutamente come una community intima e selezionata, per garantire un livello di attenzione che normalmente non \u00e8 possibile nei percorsi pi\u00f9 grandi.\n\nQuesto sar\u00e0 possibile attraverso:\n\u2022 Live di gruppo ristrette, dove potrai interagire direttamente con me, fare domande e ricevere risposte personalizzate senza dispersione;\n\u2022 Chat Telegram dedicata, dove sono presente ogni giorno per supportarti in modo diretto, continuo e vicino;\n\u2022 Community piccola e selezionata, pensata per mantenere qualit\u00e0, presenza costante e un rapporto reale con ogni membro.\n\nIl vantaggio di questa struttura \u00e8 proprio la possibilit\u00e0 di avere una coach realmente presente, accessibile e coinvolta, senza la distanza tipica delle community numerose.",
  },
  {
    q: "Posso pagare OLTRE \u2013 Light Workers\u2019 House + Mentoring a rate?",
    a: "S\u00ec.\nSe desideri entrare in OLTRE \u2013 Light Workers\u2019 House + Mentoring 1:1, puoi scegliere anche il pagamento dilazionato in 4 rate da 500 \u20ac.\n\nPer attivare il piano rateale, contatta direttamente Alessia:\n\ud83d\udce9 info@stellasoulcoach.com\noppure scrivile un DM su Instagram.\n\nInsieme troverete la modalit\u00e0 pi\u00f9 adatta per permetterti di iniziare il tuo percorso.",
  },
  {
    q: "Quali opportunit\u00e0 avr\u00f2 all\u2019interno di Light Workers House?",
    a: "La missione dietro Light Workers House \u00e8 quella di creare opportunit\u00e0 di connessione tra i membri su vari livelli, cos\u00ec che possiate portare la vostra vita personale e spirituale al livello successivo. Con gli eventi dal vivo, i Cerchi di Luce e le opportunit\u00e0 di networking, potrai connetterti con gli altri membri della Community e trovare supporto e ispirazione per il tuo percorso, in ogni area della tua vita.",
  },
  {
    q: "Ho un\u2019altra domanda, dove la posso fare?",
    a: "Puoi scrivermi su Instagram in DM (@stella_soul_coach) oppure scrivere via mail a info@stellasoulcoach.com",
  },
];

const FaqItem = ({ faq, index }) => {
  const [open, setOpen] = useState(false);

  return (
    <div
      className="border-b border-[#AC8E60]/15 last:border-b-0"
      data-testid={`faq-item-${index}`}
    >
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between py-6 text-left group"
        data-testid={`faq-toggle-${index}`}
        aria-expanded={open}
      >
        <span className="font-heading text-lg md:text-xl font-medium text-[#442F23] pr-4 group-hover:text-[#AC8E60] transition-colors">
          {faq.q}
        </span>
        <ChevronDown
          size={20}
          className={`text-[#AC8E60] flex-shrink-0 transition-transform duration-300 ${
            open ? "rotate-180" : ""
          }`}
        />
      </button>
      <motion.div
        initial={false}
        animate={{ height: open ? "auto" : 0, opacity: open ? 1 : 0 }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
        className="overflow-hidden"
      >
        <div className="font-body text-sm text-[#442F23]/70 leading-relaxed pb-6 pr-8 whitespace-pre-line">
          {faq.a.includes("N.B.:") ? (
            <>
              {faq.a.split("N.B.:")[0]}
              <strong className="text-[#442F23]">N.B.: {faq.a.split("N.B.:")[1]}</strong>
            </>
          ) : (
            faq.a
          )}
        </div>
      </motion.div>
    </div>
  );
};

const FaqSection = () => {
  return (
    <section
      data-testid="faq-section"
      className="py-24 md:py-32 bg-[#F5F0EB]"
    >
      <div className="max-w-3xl mx-auto px-6 lg:px-12">
        <AnimatedBlock>
          <div className="text-center mb-16">
            <p className="text-sm uppercase tracking-[0.2em] text-[#AC8E60] font-body font-semibold mb-4">
              Hai domande?
            </p>
            <h2 className="font-heading text-4xl md:text-5xl font-semibold tracking-tight text-[#442F23] mb-6">
              Domande frequenti
            </h2>
            <div className="section-divider" />
          </div>
        </AnimatedBlock>

        <AnimatedBlock delay={0.1}>
          <div className="bg-[#FBF8E9] border border-[#AC8E60]/10 rounded-[2rem] px-8 md:px-10">
            {faqs.map((faq, i) => (
              <FaqItem key={i} faq={faq} index={i} />
            ))}
          </div>
        </AnimatedBlock>

        <AnimatedBlock delay={0.2}>
          <div className="text-center mt-12">
            <p className="font-body text-sm text-[#442F23]/60 mb-4">
              Non hai trovato la risposta che cercavi?
            </p>
            <a
              href="mailto:info@stellasoulcoach.com"
              className="font-body text-sm font-semibold text-[#AC8E60] hover:text-[#E1C340] transition-colors"
              data-testid="faq-contact-link"
            >
              Scrivimi a info@stellasoulcoach.com
            </a>
          </div>
        </AnimatedBlock>
      </div>
    </section>
  );
};

export default FaqSection;
